import './style/index.less'
import CommonPopup from "./CommonPopup";

export default CommonPopup